<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'md'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <CRow>
        <CCol style="text-align: center">
          <h5 class="modal-title">
            ¿Desea Borrar el registro?
          </h5>
        </CCol>
        <!-- <CCol v-if="state_payment != 0" sm="12" class="mt-2">
          <CSelect label="Método de pago de la cancelación" :value.sync="turned.method" :options="turnedMethod"
            placeholder="--Seleccione un metodo--" />
        </CCol> -->
      </CRow>
    </div>
    <template #footer>
      <CButton class="btn btn-danger" @click="mtdClose" :style="{ color: 'white' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
      <CButton class="btn btn-success" :style="{ color: 'white' }" @click="mtd_commit">
        <i class="fas fa-trash"></i>&nbsp;Eliminar
      </CButton>
    </template>
  </CModal>
</template>
<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
export default {
  name: "c-eliminar-modal",
  components: {
    CModal,
  },
  data() {
    return {
      prefix: "cita",
      swal: null,
      turnedMethod: [],
      turned: {
        method: 0,
      },
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    id_reserva: Number,
    state_payment: Number,
  },
  watch: {
    boo_modal(newVal) {
      if (newVal) {
        this.showMethodPayment();
      }
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose(refresh = false) {
      this.$emit("closeModalEliminar", refresh);
      this.turnedMethod = [];
    },
    showMethodPayment() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byMethodPayment/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { Id, name } = arr;
            this.turnedMethod.push({
              label: name,
              value: Id,
            });
          });
        })
        .catch((errors) => { });
    },
    mtd_commit() {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.$props.id_reserva,
          campu_id: this.$store.getters.get_campu.id,
          user_id: this.$store.getters.get__user_id,
          method_payment: this.turned,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            Swal.fire({
              icon: "success",
              title: "ELIMINADO CORRECTAMENTE",
            });
            this.mtdClose(true);
          }
        })
        .catch((errors) => {
          Swal.fire({
            icon: "danger",
            title: "ERROR AL ELIMINAR",
          });
        });
    },
  },
};
</script>
<style></style>